// Module
var code = "<hero-customizer-v3-image-gallery group=\"group\" on-close=\"onClose()\" items=\"items\"></hero-customizer-v3-image-gallery>";
// Exports
module.exports = code;